// extracted by mini-css-extract-plugin
export default {"innerWrapper":"sC-z","tooltipWrapper":"tC-z","icon":"uC-z","tooltip":"vC-z","content":"wC-z"};